import React, { InputHTMLAttributes, useState, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Field } from 'formik';

export interface FormikCheckboxProps
  extends InputHTMLAttributes<HTMLInputElement> { }

export const Checkbox: React.FC<FormikCheckboxProps> = ({
  checked,
  form,
  width,
  height,
  ...others
}) => {
  const classes = useStyles();
  console.log(others)
  const toggleCheck = useCallback(() => {
    (form as any).setFieldValue(others.name, !checked);
  }, [form, checked, others.name]);

  return (
    <div className={classes.container} style={{
      width: width ? width : 'none', height: height ? height : 'none',
    }} onClick={toggleCheck}>
      <input type="checkbox" {...others} checked={checked} />
      <span className={classes.checkmark} />
    </div>
  );
};

const FormikCheckbox: React.FC<FormikCheckboxProps> = ({ name, ...others }) => {
  return (
    <Field name={name}>
      {({ field, form }: { field: any; form: any }) => (
        <Checkbox {...field} form={form} {...others} />
      )}
    </Field>
  );
};

const useStyles = createUseStyles({
  /* Customize the label (the container) */
  container: {
    display: 'inline-block',
    position: 'relative',
    paddingLeft: '35px',
    marginBottom: '12px',
    cursor: 'pointer',
    fontSize: '22px',
    userSelect: 'none',
    height: '25px',
    '& input': {
      /*  Hide the browser's default checkbox  */
      position: 'absolute',
      opacity: 0,
      cursor: 'pointer',
      height: 0,
      width: 0,
      /* Show the checkmark when checked */
      '&:checked': {
        '& ~ $checkmark': {
          /* When the checkbox is checked, add a blue background */
          '&:after': {
            display: 'block',
          },
        },
      },
    },

    '& $checkmark': {
      '&:after': {
        left: '9px',
        top: '5px',
        width: '5px',
        height: '10px',
        border: 'solid #bdbdbd',
        borderWidth: '0 3px 3px 0',
        transform: 'rotate(45deg)',
      },
    },

    /* On mouse-over, add a grey background color */
    '&:hover': {
      '& input': {
        '& ~ $checkmark': {
          backgroundColor: '#eee',
        },
      },
    },
  },

  checkmark: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '25px',
    width: '25px',
    backgroundColor: '#f5f5f5',
    borderRadius: '5px',
    border: '2px solid #dadada',
    '&:after': {
      content: '""',
      position: 'absolute',
      display: 'none',
    },
  },
});

export default FormikCheckbox;
